import { defineComponent as _defineComponent } from 'vue'
import CaretRightIcon from '@/assets/images/svg/caret-right.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPagination',
  props: {
    currentPage: null,
    totalPages: null
  },
  emits: ["pageChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'pageChange', page: number): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, CaretRightIcon }
}

})